import { BaseSlideAppService } from '../../../core/services/slide-app-service.base';

/**
 * 在线文档 3.0
 */
export class OnlineSlideAppService extends BaseSlideAppService {
    protected init() {
    }
}
